import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { updateRoutePolylineFeature } from './breadcrumbAndRoutePath/updateRoutePolylineFeature'
import { findRoutePolylineMarker } from './findRoutePolylineMarker'

const nonblockingRender = createNonBlockingRenderByTime()

/**
 * Update RoutePolylines features when related Map styles change
 */
export async function mapStylesUpdateRoutePolylineFeatures(
  layer: VectorLayer<VectorSource>,
  markers: Record<string, uui.domain.ui.map.markers.RoutePolyline>,
  mapStyles: uui.domain.ui.map.markers.MapStyles['routePolyline'],
) {
  const features = (layer.getSource()?.getFeatures() ?? []).filter(
    feature => feature.get('type') === 'routePolyline',
  )

  nonblockingRender.reset()

  for (let index = 0; index < features.length; index++) {
    await nonblockingRender.next()

    const feature = features[index]

    if (!feature) {
      if (process.env.NODE_ENV === 'development') {
        throw new Error(
          `Trying to update RoutePolyline marker style but no feature exist at index ${index}`,
        )
      }

      continue
    }

    const featureId = feature.getId() as string | undefined

    if (!featureId) {
      if (process.env.NODE_ENV === 'development') {
        throw new Error(
          `Trying to update RoutePolyline marker style but the feature found at index ${index} has no ID`,
        )
      }

      continue
    }

    const marker = findRoutePolylineMarker(markers, featureId)
    const customMode = marker.mode

    // do not process marker with custom mode
    // custom mode is are managed through a marker changelog
    if (customMode) continue

    updateRoutePolylineFeature(mapStyles, marker, feature)
  }
}
